import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { Card2 } from "@/ui2/atoms/Card";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Heading2 } from "@/ui2/atoms/Heading";

type PolicyProps = {
  effectiveDate: string;
  submitHandler: () => Promise<void>;
};

export function UpdatedCancellationPolicy({ effectiveDate, submitHandler }: PolicyProps) {
  return (
    <Card2 className="tw:flex-col tw:gap-8 tw:p-12">
      <header className="tw:flex tw:flex-col tw:items-center tw:gap-2">
        <Heading2 as="h1" size={4}>
          Updated Cancellation Policy
        </Heading2>

        <span className="body-md tw:text-text-tertiary">Effective as of {effectiveDate}</span>
      </header>

      <div className="body-md tw:flex tw:flex-col tw:gap-5">
        <p>
          With the growing need for behavioral healthcare and a national shortage of behavioral
          health specialists, it’s important that appointments not be skipped or cancelled so that
          aptihealth’s therapists and prescribers can spend that time with other members. In an
          effort to reduce the number of skipped or cancelled appointments,{" "}
          <strong>we have implemented a new Cancellation Policy.</strong>
        </p>

        <p>
          <strong>
            Effective immediately, aptihealth requires 24 hours’ notice when making appointment
            changes
          </strong>
          , which includes the cancellation and rescheduling of appointments. Providing less than 24
          hours’ notice, or skipping the appointment completely, will be considered a cancellation
          of the scheduled appointment.
        </p>

        <p>
          If 3 cancellations occur within a 60-day period, we may consider ending your service with
          aptihealth. Of course, we understand that emergencies arise and will take that into
          consideration. Please communicate with your therapist directly and as soon as possible
          when an emergency occurs.
        </p>

        <p>
          <strong>
            If you skip an appointment or fail to provide 24 hours’ notice of an appointment change,
            you may be charged.
          </strong>{" "}
          That fee will depend on the type of session:
        </p>

        <ul className="tw:space-y-0.5 tw:pl-10!">
          <li className="tw:list-disc!">Therapist consultation: $150.00</li>
          <li className="tw:list-disc!">Medication consultation: $150.00</li>
          <li className="tw:!list-disc!">Therapy session: $75.00</li>
          <li className="tw:list-disc!">Medication management session: $95.00</li>
        </ul>

        <p>Making excessive appointment changes may result in a change of scheduling options.</p>

        <p>
          This policy will allow us to make our therapists and prescribers available to more
          members, so they can receive the same dedicated care that you do. We appreciate your
          respect of our team’s time and cooperation in helping us deliver timely care.
        </p>
      </div>

      <Button2
        className="tw:mx-auto tw:self-center"
        onPress={submitHandler}
        {...getAutomationDataAttr("policy-acknowledgement-button")}
      >
        Acknowledge
      </Button2>
    </Card2>
  );
}
